import { Dimensions } from 'react-native'
import { BoxProps } from '../BoxNew'
import { TextProps } from '../TextNew'

const defaultHeader = {
  paddingHorizontal: 16,
  paddingVertical: 12,
  flexDirection: 'row',
  alignItems: 'center',
  borderTopEndRadius: 16,
  borderTopStartRadius: 16,
  backgroundColor: 'GREY_SEPARATOR',
  overflow: 'hidden',
  justifyContent: 'space-between',
}

const defaultHeaderTitle = {
  type: 'titleBold18',
  color: 'BLACK_75',
} as TextProps

const defaulBackground = {
  position: 'absolute',
  bottom: 0,
  top: 0,
  left: 0,
  right: 0,
  zIndex: -1,
  backgroundColor: '#000000bb',
}

const modalTypes = {
  bottom: {
    contentContainer: {
      flex: 1,
      paddingTop: 200,
      justifyContent: 'flex-end',
    } as BoxProps,
    innerContainer: {
      backgroundColor: 'WHITE',
      maxHeight: Dimensions.get('window').height - 50,
    } as BoxProps,
    background: {
      ...defaulBackground,
      // backgroundColor: 'RED',
      // bottom: 40,
    } as BoxProps,
  },
  centered: {
    contentContainer: {
      flex: 1,
      paddingHorizontal: 24,
      paddingVertical: 96,
      justifyContent: 'center',
    } as BoxProps,
    innerContainer: {
      backgroundColor: 'WHITE',
      borderRadius: 16,
      maxHeight: Dimensions.get('window').height,
    } as BoxProps,
    background: {
      ...defaulBackground,
    } as BoxProps,
  },
  centeredWrap: {
    contentContainer: {
      flex: 1,
      paddingHorizontal: 24,
      paddingVertical: 96,
      justifyContent: 'center',
    } as BoxProps,
    innerContainer: {
      backgroundColor: 'WHITE',
      alignSelf: 'center',
      borderRadius: 16,
      maxHeight: Dimensions.get('window').height - 50,
    } as BoxProps,
    background: {
      ...defaulBackground,
    } as BoxProps,
  },
}
const defaultContainerButton = {
  backgroundColor: 'WHITE',
  height: 36,
  width: 36,
  borderRadius: 36 / 2,
  alignItems: 'center',
  justifyContent: 'center',
}

const modalHeaderType = {
  default: {
    containerHeader: (center: any) =>
    ({
      ...defaultHeader,
      justifyContent: center ? 'center' : 'space-between',
    } as BoxProps),
    headerTitle: {
      type: 'titleBold18',
      color: 'BLACK',
    } as TextProps,
    containerButton: { ...defaultContainerButton } as BoxProps,
  },
  whiteBg: {
    containerHeader: (center: any) =>
      ({ ...defaultHeader, backgroundColor: 'WHITE', justifyContent: center ? 'center' : 'space-between' } as BoxProps),
    headerTitle: {
      ...defaultHeaderTitle,
    } as TextProps,
    containerButton: { ...defaultContainerButton } as BoxProps,
  },
}

export { modalTypes, modalHeaderType }
